// removed by extract-text-webpack-plugin
module.exports = {"layout-classic-wrapper":"layout-classic-wrapper___1Cxhj","layout-classic-main":"layout-classic-main___o7pgW","layout-classic-content-wrapper":"layout-classic-content-wrapper___2hmMm","layout-classic-content":"layout-classic-content___3SSuD"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout-classic/layout-classic.module.scss
// module id = 1341
// module chunks = 82